export const READING_LOCATION = Object.freeze({
  HOME: 'home',
  DIALYSIS: 'dialysis',
});

export const READING_SOURCE = Object.freeze({ MANUAL: 'manual', OMRON: 'omron' });

export const DIALYSIS_ATTENDANCE_STATUS = Object.freeze({ ATTENDED: 'ATTENDED', NO: 'NO' });
export const FLUID_ACTION = Object.freeze({
  NONE: 'none',
  SYMPTOMS: 'symptoms',
  ALERT: 'alert',
  NOTICE: 'notice',
});
export const FLUID_ALERT_REASON = Object.freeze({ IDWG: 'IDWG', DIALYSIS_GAP: 'DIALYSIS_GAP' });

export const FLUID_QUERY = Object.freeze({
  ENTRY: 'entry',
  DRY_WEIGHT_REVIEW: 'reviewDryWeight',
});

export const DIALYSIS_PHASE = Object.freeze({
  BEFORE: 'before',
  AFTER: 'after',
});

// Which measurement of the day an entry or device sync belongs to.
export const READING_PART = Object.freeze({
  REGULAR: 'regular',
  BEFORE: DIALYSIS_PHASE.BEFORE,
  AFTER: DIALYSIS_PHASE.AFTER,
});

export const READING_HISTORY_VIEW = Object.freeze({
  GRAPH: 'graph',
  TABLE: 'table',
});
export const READING_HISTORY_DATE_BASIS = Object.freeze({
  MEASUREMENT: 'measurement',
  SAVED: 'saved',
});

export const MEASUREMENT_RANGE = Object.freeze({
  weight: { min: 0.1, max: 500, multipleOf: 0.01 },
  systolic: { min: 50, max: 300 },
  diastolic: { min: 30, max: 200 },
  heartRate: { min: 20, max: 250 },
});
export const DRY_WEIGHT_RANGE = Object.freeze({
  MIN_KG: MEASUREMENT_RANGE.weight.min,
  MAX_KG: MEASUREMENT_RANGE.weight.max,
  MULTIPLE_OF_KG: MEASUREMENT_RANGE.weight.multipleOf,
});

export const READING_HISTORY_RANGE = Object.freeze({ WEEK: 7, MONTH: 30 });
export const READING_THRESHOLD = Object.freeze({
  IDWG_HIGH: 4,
});

export const MEASUREMENT_FIELDS = Object.freeze([
  {
    key: 'weight',
    label: 'weight',
    unit: 'kg',
    step: 1,
    inputmode: 'decimal',
    fullWidth: true,
  },
  {
    key: 'systolic',
    label: 'systolic',
    unit: 'mmHg',
    step: 1,
    inputmode: 'decimal',
    fullWidth: false,
  },
  {
    key: 'diastolic',
    label: 'diastolic',
    unit: 'mmHg',
    step: 1,
    inputmode: 'decimal',
    fullWidth: false,
  },
  {
    key: 'heartRate',
    label: 'heartRate',
    unit: 'bpm',
    step: 1,
    inputmode: 'numeric',
    fullWidth: true,
  },
]);
